import type { AuthProfile } from '@/hooks/useAuth';

/** Sidebar/account label: full_name → company_name → session email → role fallback */
export function getProfileDisplayName(
  profile: AuthProfile | null | undefined,
  roleLabel: string,
  sessionEmail?: string | null,
): string {
  const fullName = profile?.full_name?.trim();
  if (fullName) return fullName;
  const companyName = profile?.company_name?.trim();
  if (companyName) return companyName;
  const email = profile?.email?.trim() || sessionEmail?.trim();
  if (email) return email;
  return roleLabel;
}
